export default __webpack_public_path__ + "b83de759a0b7863c4f7155a5162e2343.png";